/**
 * Serviço para gerenciamento de autenticação e tokens
 */

// Armazena o token em localStorage para persistência entre recarregamentos
const getToken = () => {
  try {
    // console.log('getToken chamado')
    const _token = global.token || localStorage.getItem('auth_token');
    if (_token === 'global.token') {_token = ''}
    // console.log('getToken retornou:', _token);
    return _token || '';

    // const _token = localStorage.getItem('auth_token');
    // return _token || '';
    // // // Usando novo token do localStorage
    // const _token = localStorage.getItem('token');
    // return _token || '';
  } catch (error) {
    console.error('Erro ao recuperar token:', error);
    return '';
  }
};

const setToken = (token) => {
  try {
    // Atualiza tanto o global quanto o localStorage
    global.token = token;
    localStorage.setItem('auth_token', token);

    // Dispara um evento para notificar outros componentes
    window.dispatchEvent(new Event('tokenUpdated'));

    return true;
  } catch (error) {
    return false;
  }
};

const clearToken = () => {
  try {
    global.token = '';
    localStorage.removeItem('auth_token');
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');

    // Dispara um evento para notificar outros componentes
    window.dispatchEvent(new Event('tokenUpdated'));

    return true;
  } catch (error) {
    return false;
  }
};

// Inicializa o token global a partir do localStorage
const initToken = () => {
  const storedToken = localStorage.getItem('auth_token') || localStorage.getItem('token');
  if (storedToken) {
    global.token = storedToken;
  }
};

const authService = {
  getToken,
  setToken,
  clearToken,
  initToken
};

export default authService;
